import Fridge from 'fridge'
import config from './config'

const api = Fridge.client({
  api_endpoint: config.api_uri
})

export default api



// WEBPACK FOOTER //
// ./app/api.js